import React, {Component} from 'react';
import _ from 'lodash';
import moment from 'moment';
import Workbook from 'react-excel-workbook';
import {
  SelectField,
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
  Card,
  CardTitle,
  CardText,
  LinearProgress,
  TablePagination,
  Grid,
  Cell,
  Button,
  DatePicker,
} from 'react-md';

import loanService from './../../../services/loan';
import DefaultLayout from './../../../components/layouts/default';
import BarChart from './../../../components/molecules/charts/barChart'
import LineChart from './../../../components/molecules/charts/lineChart';
import TableActions from './../../../components/molecules/tableActions';
import ReportsNav from './../../../components/atoms/subNavs/reportsNav';

import FlatOrIconButton from './../../../components/atoms/flatOrIconButton';

class LoanReport extends Component {

  constructor(props) {
    super(props);
    this.state = {
      historicData: null,
      slicedHistoricData: null,
      loading: false,
      chartInfoText: '',
      operation: '',
      historicDataStartAt: '',
      historicDataEndAt: '',
      loan: {
        data: null,
        total: 0,
      },
      renewals: {
        data: null,
        total: 0,
      },
      loanAndRenewalsTableData: [],
      slicedLoanAndRenewalsTableData: [],
      loanStartMonth: '',
      loanStartYear: '',
      loanEndMonth: '',
      loanEndYear: '',
      showLoanCustomRangePickers: false
    };
    this.formatDate = this.formatDate.bind(this);
    this.getHistoricData = this.getHistoricData.bind(this);
    this.getLoan = this.getLoan.bind(this);
    this.getLoansAndRenewals = this.getLoansAndRenewals.bind(this);
    this.setLoanAndRenewalsTableData = this.setLoanAndRenewalsTableData.bind(this);
    this.handleHistoricDataPagination = this.handleHistoricDataPagination.bind(this);
    this.handleLoanAndRenewalsPagination = this.handleLoanAndRenewalsPagination.bind(this);
  }

  componentDidMount() {
    this.getLoansAndRenewals('month');
  }

  formatDate(date) {
    const startWithYear = /^[0-9]{4}/.test(date);
    const newDate = startWithYear ? date.slice(0, 10).split('-') : date.slice(0, 10).split('/');
    const hour = date.slice(11,);
    const day = startWithYear ? newDate[2] : newDate[0];
    const month = newDate[1];
    const year = startWithYear ? newDate[0] : newDate[2];
    return `${day}/${month}/${year} ${hour}`;
  }

  handleHistoricDataPagination(start, rowsPerPage) {
    this.setState({
      slicedHistoricData: this.state.historicData.slice(start, start + rowsPerPage)
    });
  };

  handleLoanAndRenewalsPagination(start, rowsPerPage) {
    this.setState({
      slicedLoanAndRenewalsTableData: this.state.loanAndRenewalsTableData.slice(start, start + rowsPerPage)
    });
  };

  async getLoansAndRenewals(type) {

    let params = {}
    let monthly = false
    let chartInfoText = ''

    switch (type) {
      
      case 'range':
        if (
          this.state.loanStartYear == '' || this.state.loanStartMonthNumber == '' ||
          this.state.loanEndYear == '' || this.state.loanEndMonthNumber == ''
        ) {
          alert("Error: Ingrese la información completa de Mes y Año de Inicio y Fin")
          return
        }
        const startDate = moment(this.state.loanStartYear + '-' + this.state.loanStartMonthNumber + '-' + '1', 'YYYY-MM-DD')
        const endDate = moment(this.state.loanEndYear + '-' +  this.state.loanEndMonthNumber + '-' + '1', 'YYYY-MM-DD')

        if (endDate < startDate) {
          alert("Error: El mes de inicio debe ser antes del mes final.")
          return
        }

        params = {
          start_at: startDate.format('YYYY-MM-DD'),
          end_at: endDate.format('YYYY-MM-DD'),
          type: 'range',
        }
        monthly = true
        chartInfoText = 'Mostrando desde ' + this.state.loanStartMonth + ' ' + this.state.loanStartYear + ' hasta ' + this.state.loanEndMonth + ' ' + this.state.loanEndYear + '.'
        break;

      case 'day':
        params = { 
          type: type,
        }
        chartInfoText = 'Mostrando Hoy'
        break;

      case 'week':
        params = { 
          type: type,
        }
        chartInfoText = 'Mostrando Últimos 7 Días'
        break;

      case 'month':
        params = { 
          type: type,
        }
        chartInfoText = 'Mostrando Último Mes'
        break;

    }

    this.setState({
      loading: true,
      loan: {
        data: null,
        total: 0
      },
      renewals: {
        data: null,
        total: 0
      },
      chartInfoText: chartInfoText
    });

    const loansData = await this.getLoan({...params, operation: 'LOAN'}, monthly)
    const renewalsData = await this.getRenewals({...params, operation: 'RENEW'}, monthly)

    this.setState({
      loading: false,
      loan: {
        data: loansData,
        total: loansData.reduce((total, element) => {
          return total + element.Préstamos;
        }, 0),
      },
      renewals: {
        data: renewalsData,
        total: renewalsData.reduce((total, element) => {
          return total + element.Renovaciones;
        }, 0),
      },
      showMonthlyData: type === 'range'
    }, () => {
      this.setLoanAndRenewalsTableData()
    })
  }

  getLoan(params, monthly) {

    return loanService.generalReportsLoan(params, monthly)
      .then(response => {
        const map_ok = response
          .map(element => ({
            Préstamos: element.count,
            result: element.result,
            Fecha: element.trace_date,
          }))
          .sort((prev, next) => {
            if (moment(prev.Fecha) < moment(next.Fecha)) return -1;
            if (moment(prev.Fecha) > moment(next.Fecha)) return 1;
            return 0;
          })
          .map(el => ({
            ...el,
            Fecha: monthly ? ( el.Fecha ) : (`${moment(el.Fecha).format('DD-MM-YYYY')} / ${el.Fecha.slice(11,)}`),
          }))
          .filter(function (item) {
            return item.result === 'OK';
          });

        return map_ok

      });
  }

  getRenewals(params, monthly) {

    return loanService.generalReportsLoan(params, monthly)
      .then(response => {

        const map_ok = response
          .map(element => ({
            Renovaciones: element.count,
            result: element.result,
            Fecha: element.trace_date,
          }))
          .sort((prev, next) => {
            if (moment(prev.Fecha) < moment(next.Fecha)) return -1;
            if (moment(prev.Fecha) > moment(next.Fecha)) return 1;
            return 0;
          })
          .map(el => ({
            ...el,
            Fecha: monthly ? ( el.Fecha ) : (`${moment(el.Fecha).format('DD-MM-YYYY')} / ${el.Fecha.slice(11,)}`),
          }))
          .filter(function (item) {
            return item.result === 'OK';
          });
        return map_ok
      });
  }

  setLoanAndRenewalsTableData() {
    
    let tableData = []
    const MONTH_ITEMS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    
    this.state.loan.data.map((item, index) => {
      const monthNumber = parseInt(item.Fecha.substring(5,7))
      const monthString = MONTH_ITEMS[monthNumber - 1]
      const yearString = item.Fecha.substring(0,4)

      tableData.push({
        'Mes': monthString + ' ' + yearString,
        'Préstamos': item['Préstamos'],
        'Renovaciones': this.state.renewals.data[index].Renovaciones
      })
    })

    this.setState({
      loanAndRenewalsTableData: tableData.reverse(),
      slicedLoanAndRenewalsTableData: tableData.slice(0,10)
    })
    
  }

  getHistoricData() {

    if (this.state.historicDataStartAt === '') {
      alert("Seleccione una fecha de inicio.")
      return
    }
    if (this.state.historicDataEndAt === '') {
      alert("Seleccione una fecha de fin.")
      return
    }

    const startDate = moment(this.state.historicDataStartAt, 'YYYY-MM-DD')
    const endDate = moment(this.state.historicDataEndAt, 'YYYY-MM-DD')
    const daysDifference = endDate.diff(startDate, 'days');

    if (daysDifference >= 90) {
      alert("El rango debe ser de máximo 90 días.")
      return
    }

    this.setState({
      loading: true,
      historicData: [],
      slicedHistoricData: [],
    });

    let params = {
      limit: 500,
      operation: 'LOAN',
      result: 'OK'
    };

    params = {...params, start_at: this.state.historicDataStartAt};
    params = {...params, end_at: this.state.historicDataEndAt};
    
    return loanService.userTraces(params)
      .then(response => {
        let data = response
          .filter(({result}) => !/error/ig.test(result))
          .map(element => ({
            'Usuario': element.username,
            'Operación': element.operation,
            'Código de barras': element.barcode,
            'Resultado': element.result,
            'Fecha de transacción': element.inserted_at ? this.formatDate(element.inserted_at) : element.inserted_at,
            'Fecha de devolución': element.data ? this.formatDate(element.data) : element.data,
          }));

        this.setState({
          historicData: data,
          slicedHistoricData: data.slice(0, 10),
          loading: false,
        });
      });
  }

  render() {

    const MONTH_ITEMS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    const YEAR_ITEMS = ['2018', '2019']

    let TablePageSection = null

    if (this.state.showMonthlyData) {

      TablePageSection = (
        <Card tableCard>
          <TableActions title='Consolidado Mensual' count={0} onResetClick={() => this.getLoansAndRenewals('range')} />
          {this.state.loading && <LinearProgress id='usersProgress' />}
          <Grid>

            <Workbook
              filename='consolidadoMensual.xlsx'
              element={!this.state.loading
                ? <Button
                  raised
                  primary
                  iconEl={<FlatOrIconButton
                    iconChildren='folder'
                    style={{color: '#fff'}}>»Exportar</FlatOrIconButton>} />
                : <Button
                  raised
                  primary
                  iconEl={<FlatOrIconButton
                    iconChildren='folder'
                    style={{color: '#fff'}}>Cargando...</FlatOrIconButton>} />
              }>
              <Workbook.Sheet
                data={this.state.loanAndRenewalsTableData}
                name='Consolidado Mensual'>
                <Workbook.Column
                  label='Mes'
                  value='Mes' />
                <Workbook.Column
                  label='Préstamos'
                  value='Préstamos' />
                <Workbook.Column
                  label='Renovaciones'
                  value='Renovaciones' />
              </Workbook.Sheet>
            </Workbook>
          </Grid>

          <DataTable baseId='dynamic-content-desserts'>
            {!this.state.loanAndRenewalsTableData && (
              <tbody>
                <tr>
                  <td style={{textAlign: 'center', padding: '10px'}}>Sin Registro</td>
                </tr>
              </tbody>
            )}
            {this.state.loanAndRenewalsTableData && (
              <React.Fragment>
                <TableHeader>
                  <TableRow>
                    {this.state.slicedLoanAndRenewalsTableData.length > 0 && Object.keys(this.state.slicedLoanAndRenewalsTableData[0]).map((header, i) => (
                      <TableColumn key={`${header}_${i}`}>{header}</TableColumn>
                    ))}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {this.state.slicedLoanAndRenewalsTableData.map((item, i) => (
                    <TableRow key={`${item.id}_${i}`}>
                      {Object.keys(item).map(key => (
                        <TableColumn key={key}>{item[key]}</TableColumn>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
                <TablePagination
                  rows={this.state.loanAndRenewalsTableData.length}
                  rowsPerPageLabel='Registros por página'
                  onPagination={this.handleLoanAndRenewalsPagination}
                />
              </React.Fragment>
            )}
          </DataTable>
        </Card>
      )

    } else {

      TablePageSection = (
        <Card tableCard>
          <TableActions title='Histórico Préstamos' count={0} onResetClick={this.getHistoricData} />
          {this.state.loading && <LinearProgress id='usersProgress' />}
          <Grid>
            <DatePicker
              id='date-picker-auto-ok'
              label='Desde'
              autoOk
              className='md-cell md-cell--bottom'
              onChange={(value) => this.setState({historicDataStartAt: value.replace(/\//g, '-').split('-').reverse().join('-')})}
              locales='es-ES'
            />
            <DatePicker
              id='date-picker-auto-ok'
              label='Hasta'
              autoOk
              className='md-cell md-cell--bottom'
              onChange={(value) => this.setState({historicDataEndAt: value.replace(/\//g, '-').split('-').reverse().join('-')})}
              locales='es-ES'
            />
            <Button
              type='submit'
              className='md-cell md-cell--bottom'
              onClick={() => this.getHistoricData()}
              primary
              flat
            >
              Buscar
            </Button>
            <Workbook
              filename='ReporteDePrestamos.xlsx'
              element={!this.state.loading
                ? <Button
                  raised
                  primary
                  iconEl={<FlatOrIconButton
                    iconChildren='folder'
                    style={{color: '#fff'}}>»Exportar</FlatOrIconButton>} />
                : <Button
                  raised
                  primary
                  iconEl={<FlatOrIconButton
                    iconChildren='folder'
                    style={{color: '#fff'}}>Cargando...</FlatOrIconButton>} />
              }>
              <Workbook.Sheet
                data={this.state.historicData}
                name='Reportes'>
                <Workbook.Column
                  label='Usuario'
                  value='Usuario' />
                <Workbook.Column
                  label='Operación'
                  value='Operación' />
                <Workbook.Column
                  label='Código de barras'
                  value='Código de barras' />
                <Workbook.Column
                  label='Resultado'
                  value='Resultado' />
                <Workbook.Column
                  label='Fecha de transacción'
                  value='Fecha de transacción' />
                <Workbook.Column
                  label='Fecha de devolución'
                  value='Fecha de devolución' />
              </Workbook.Sheet>
            </Workbook>
          </Grid>
          <DataTable baseId='dynamic-content-desserts'>
            {!this.state.historicData && (
              <tbody>
                <tr>
                  <td style={{textAlign: 'center', padding: '10px'}}>Sin Registro</td>
                </tr>
              </tbody>
            )}
            {this.state.historicData && (
              <React.Fragment>
                <TableHeader>
                  <TableRow>
                    {this.state.slicedHistoricData.length > 0 && Object.keys(this.state.slicedHistoricData[0]).map((header, i) => (
                      <TableColumn key={`${header}_${i}`}>{header}</TableColumn>
                    ))}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {this.state.slicedHistoricData.map((item, i) => (
                    <TableRow key={`${item.id}_${i}`}>
                      {Object.keys(item).map(key => (
                        <TableColumn key={key}>{item[key]}</TableColumn>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
                <TablePagination
                  rows={this.state.historicData.length}
                  rowsPerPageLabel='Registros por página'
                  onPagination={this.handleHistoricDataPagination}
                />
              </React.Fragment>
            )}
          </DataTable>
        </Card>
      )

    }

    return (

      <DefaultLayout>
        <Grid>
          <Cell size={12}>
            <ReportsNav />
          </Cell>

          <Cell size={12}>
            <br />
            <Card style={styles.card}>
              <Grid>
                <CardTitle title={this.state.loan.total} subtitle='Préstamos' />
                <CardTitle title={this.state.renewals.total} subtitle='Renovaciones' />
                <CardTitle title={''} subtitle='' />
              </Grid>
              <CardText>
                {(this.state.loading) && (
                  <LinearProgress id='loanProgress' />
                )}
                {this.state.loan.data && (
                  <React.Fragment>
                    <hr />
                    <Button
                      flat
                      primary
                      swapTheming
                      onClick={() => {
                        this.setState({
                          showLoanCustomRangePickers: false,
                          showMonthlyData: false
                        })
                        this.getLoansAndRenewals('day')
                      }}
                    >
                      Hoy
                    </Button>
                    <Button
                      flat
                      primary
                      swapTheming
                      style={{marginLeft: 10, marginRight: 10}}
                      onClick={() => {
                        this.setState({ 
                          showLoanCustomRangePickers: false,
                          showMonthlyData: false
                        })
                        this.getLoansAndRenewals('week')
                      }}
                    >
                      Últimos 7 días
                    </Button>
                    <Button
                      flat
                      primary
                      swapTheming
                      style={{marginRight: 10}}
                      onClick={() => {
                        this.setState({ 
                          showLoanCustomRangePickers: false,
                          showMonthlyData: false
                        })
                        this.getLoansAndRenewals('month')
                      }}
                    >
                      Último Mes
                    </Button>
                    <Button
                      flat
                      primary
                      swapTheming
                      onClick={() => this.setState({ showLoanCustomRangePickers: !this.state.showLoanCustomRangePickers })}
                    >
                      Consolidado Mensual
                    </Button>

                    {
                      this.state.showLoanCustomRangePickers && (
                        <div>
                          <div>
                            <SelectField
                              simplifiedMenu
                              id='start-month-select-field'
                              label='Mes (Inicio)'
                              placeholder='Mes (Inicio)'
                              className='md-cell'
                              menuItems={MONTH_ITEMS}
                              value={this.state.loanStartMonth}
                              onChange={(value, index) => {
                                  this.setState({
                                    loanStartMonth: value,
                                    loanStartMonthNumber: '' + (index+1)
                                  })
                                }
                              }
                            />
                            <SelectField
                              id='start-year-select-field'
                              label='Año (Inicio)'
                              placeholder='Año (Inicio)'
                              className='md-cell'
                              menuItems={YEAR_ITEMS}
                              simplifiedMenu={false}
                              value={this.state.loanStartYear}
                              onChange={(value, index) => {
                                  this.setState({loanStartYear: value})
                                }
                              }
                            />
                          </div>
                          
                          <div>
                            <SelectField
                              simplifiedMenu
                              id='end-month-select-field'
                              label='Mes (Fin)'
                              placeholder='Mes (Fin)'
                              className='md-cell'
                              menuItems={MONTH_ITEMS}
                              value={this.state.loanEndMonth}
                              onChange={(value, index) => {
                                  this.setState({
                                    loanEndMonth: value,
                                    loanEndMonthNumber: '' + (index+1)
                                  })
                                }
                              }
                            />
                            <SelectField
                              simplifiedMenu
                              id='end-year-select-field'
                              label='Año (Fin)'
                              placeholder='Año (Fin)'
                              className='md-cell'
                              menuItems={YEAR_ITEMS}
                              value={this.state.loanEndYear}
                              onChange={(value, index) => {
                                  this.setState({loanEndYear: value})
                                }
                              }
                            />
                          </div>
                          
                          <Button
                            primary
                            flat
                            swapTheming
                            type='submit'
                            className='md-cell md-cell--bottom'
                            onClick={() => this.getLoansAndRenewals('range')}
                          >
                            Buscar
                          </Button>
                        </div>
                      )
                    }

                    <hr />

                    <CardText>{this.state.chartInfoText}</CardText>

                    {
                      this.state.showMonthlyData ? (

                        <Grid>
                          <BarChart
                            width={480}
                            height={300}
                            data={this.state.loan.data}
                            dataKeyX='Fecha'
                            dataKeyY='Préstamos'
                            barColor='#8884d8'
                          />
                          <BarChart
                            width={480}
                            height={300}
                            data={this.state.renewals.data}
                            dataKeyX='Fecha'
                            dataKeyY='Renovaciones'
                            barColor='#82ca9d'
                          />
                        </Grid>

                      ) : (

                        <Grid>
                          <LineChart
                            width={480}
                            height={300}
                            data={this.state.loan.data}
                            dataKeyX='Fecha'
                            dataKeyY='Préstamos'
                            lineColor='#8884d8'
                          />
                          <LineChart
                            width={480}
                            height={300}
                            data={this.state.renewals.data}
                            dataKeyX='Fecha'
                            dataKeyY='Renovaciones'
                            lineColor='#82ca9d'
                          />
                        </Grid>

                      )
                    }
                    
                  </React.Fragment>
                )}

              </CardText>
            </Card>

            {TablePageSection}
            
          </Cell>
        </Grid>
      </DefaultLayout>
    );
  }
}

const styles = {
  card: {
    borderRadius: '2px',
    marginBottom: '2rem',
  },
};

export default LoanReport;



// WEBPACK FOOTER //
// ./src/pages/home/reports/index.js